import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
// import Vant from 'vant'
// import { Lazyload } from 'vant'
// import 'vant/lib/index.css'
import './assets/css/common.css'
import Api from './assets/js/api.js'
import Qiniu from './assets/js/qiniu.js'
import App from './App.vue'
import VueClipboard from 'vue-clipboard2'
// 引入amfe-flexible做rem适配
// import 'amfe-flexible'


Vue.prototype.$api = Api
Vue.prototype.$qiniu = Qiniu
Vue.config.productionTip = false
// Vue.use(Vant)
// Vue.use(Lazyload)
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueClipboard)


const Routers = [
  {
    path: '/',
    meta: {
      title: '投訴'
    },
    component: (resolve) => require(['./views/complain.vue'], resolve)
  },
  {
    path: '*',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/not_found.vue'], resolve)
  },
  {
    path: '/complain',
    meta: {
      title: '投訴'
    },
    component: (resolve) => require(['./views/complain.vue'], resolve)
  },
  {
    path: '/complain_edit',
    meta: {
      title: '投訴'
    },
    component: (resolve) => require(['./views/complain_edit.vue'], resolve)
  },
  {
    path: '/rules_user_protocal',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/rules_user_protocal.vue'], resolve)
  },
  {
    path: '/rules_privacy',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/rules_privacy.vue'], resolve)
  },
  {
    path: '/not_found',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/not_found.vue'], resolve)
  },
  {
    path: '/loading_base',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/loading_base.vue'], resolve)
  },
  {
    path: '/loading_base_test',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/loading_base_test.vue'], resolve)
  },
  {
    path: '/qrcode_for_waimaiqun',
    meta: {
      title: '省钱群'
    },
    component: (resolve) => require(['./views/qrcode_for_chihuo.vue'], resolve)
  },
  {
    path: '/qrcode_for_waimaiqun_test',
    meta: {
      title: '省钱群'
    },
    component: (resolve) => require(['./views/qrcode_for_waimaiqun_test.vue'], resolve)
  }
]

const RouterConfig = {
  mode: 'history',
  routes: Routers
}
const router = new VueRouter(RouterConfig)

const store = new Vuex.Store({
  state: {
    userinfo: {
      userid: '',
      user_type: ''
    },
    favicon: '',
    staticUrl: 'https://static.huiyiji520.com',
    siteDomain: 'https://wecom.zhishishijian.com',
    webAuthUrl: 'https://wecom.zhishishijian.com',
    siteTitle: '',
    siteSlogan: '',
    siteCode: '',
    referal: '/'
  },

  mutations: {
    setUserinfoBase(state, params){
      state.userinfo = {userid: params.userid, user_type: params.user_type}
      router.replace(params.destination)
    }
  }
});

router.beforeEach((to, from, next) => {
  // alert('store state userinfo openid: ' + store.state.userinfo.openid)
  // alert('from path: ' + JSON.stringify(from.path))
  window.document.title = to.meta.title || store.state.siteTitle
  if( (to.path === "/loading_base") || (to.path === "/loading_base_test") || (to.path === "/qrcode_for_waimaiqun") ){
    next()
  }else if(store.state.userinfo.userid){
    next()
  }else if(to.path === "/go_test"){
    window.location.replace("https://api.huiyiji520.com/api/zhishicheap/snsapi_base?url=" + store.state.webAuthUrl + "/loading_base_test?destination=" + encodeURIComponent(to.fullPath))
  }else{
    // next()
    window.location.replace("https://api.huiyiji520.com/api/zhishicheap/snsapi_base?url=" + store.state.webAuthUrl + "/loading_base?destination=" + encodeURIComponent(to.fullPath))
  }
})

new Vue({
  el: '#app',
  router: router,
  store: store,
  render: h => {
    return h(App)
  }
})

// function setHtmlFontSize () {
//   const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
//   const htmlDom = document.getElementsByTagName('html')[0]
//   htmlDom.style.fontSize = htmlWidth / 10 + 'px'
// }
// setHtmlFontSize()
// window.onresize = setHtmlFontSize
